import { Model } from './architecture'
import { Currency } from './Currency'
import { Money } from './Money'
import type { Price } from './Price'
// import { z } from 'zod'

/* 
  This produces an error because PriceDiff is used in Price.ts and causes a circular dependency
*/
// const PriceDiffValidation = z.object({
//   price: z.instanceof(Price, { message: '[PriceDiff] price is required' }),
//   priceBefore: z.instanceof(Price, { message: '[PriceDiff] priceBefore is required' }),
// })

export class PriceDiff extends Model {
  static create({ price, priceBefore }: { price: Price; priceBefore: Price }) {
    // PriceDiffValidation.parse({ price, priceBefore })
    return new PriceDiff(price, priceBefore)
  }

  constructor(
    private readonly _priceA: Price,
    private readonly _priceB: Price
  ) {
    super()
  }

  getDiff() {
    const priceTotal = this._priceA.getMoney('total')
    const priceBeforeTotal = this._priceB.getMoney('total')
    const pricePerNight = this._priceA.getMoney('perNight')
    const priceBeforePerNight = this._priceB.getMoney('perNight')

    if (!priceTotal || !priceBeforeTotal || !pricePerNight || !priceBeforePerNight) {
      return {
        total: Money.create({
          amount: 0,
          currency: Currency.create({ value: 'EUR' }),
        }),
        perNight: Money.create({
          amount: 0,
          currency: Currency.create({ value: 'EUR' }),
        }),
      }
    }

    return {
      total: Money.create({
        amount: priceBeforeTotal.amount - priceTotal.amount,
        currency: priceTotal.getCurrency(),
      }),
      perNight: Money.create({
        amount: priceBeforePerNight.amount - pricePerNight.amount,
        currency: pricePerNight.getCurrency(),
      }),
    }
  }

  isPositive() {
    return this.getDiff().total.amount >= 0
  }
}
